export type GeoFix = { latitude: number; longitude: number; accuracy: number };

/** Browser Geolocation API (requires https or localhost). */
export function getCurrentPosition(): Promise<GeoFix> {
  return new Promise((resolve, reject) => {
    if (typeof navigator === 'undefined' || !navigator.geolocation) return reject(new Error('Geolocation is not supported by this browser.'));
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ latitude: p.coords.latitude, longitude: p.coords.longitude, accuracy: p.coords.accuracy }),
      (e) => reject(new Error(e.message || 'Unable to get location')),
      { enableHighAccuracy: true, timeout: 10_000 },
    );
  });
}
